import React from 'react';
import styled from 'styled-components';
import { Footer } from '@ui';
import { Jumbotron } from './Jumbotron';
import { Testimonials } from './Testimonials';
import { UseCases } from './UseCases';
import { Security } from './Security';
import { Navbar } from './Navbar';
import { selectLightTheme } from '@utils/themes';
import { colorPalette } from '@theme';
import { useColorTheme } from '@hooks';
import { ConnectToAdapters } from './ConnectToAdapters';
import { ApiFeature } from './ApiFeature';

const PageWrapper = styled.div`
  background: ${({ theme }) => selectLightTheme(theme).header};
`;
const Body = styled.div`
  background: ${({ theme }) => selectLightTheme(theme).header};
`;

function setBodyBackground(color) {
  document.body.style.backgroundColor = color;
}

function Splash() {
  const colorTheme = useColorTheme();
  React.useEffect(() => {
    setBodyBackground(colorPalette.primary.white);
    return () => {
      setBodyBackground(colorTheme.background);
    };
  }, []);

  return (
    <PageWrapper>
      <Body>
        <Navbar />
        <Jumbotron />
        <Security />
        <Testimonials />
        <UseCases />
        <ConnectToAdapters />
        <ApiFeature />
      </Body>
      <Footer />
    </PageWrapper>
  );
}

export default Splash;
